import { render } from "./App.vue?vue&type=template&id=a0fa72fc&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a0fa72fc&scoped=true&lang=scss"

import exportComponent from "/builds/gh_devops/writeoff_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fa72fc"]])

export default __exports__